export const VOICE_ADMIN_DISABLE_DUETO_BWPATCHING =
  'Voice administration is currently disabled due to maintenance, please try back later.';
